export const sortBySetNumber = (orders) => {
    orders.sort((a, b) => {
        return (a.set_number || 0) - (b.set_number || 0)
    })
}

export const setNumberHeader = (lastOrder, order, currentSetNumber, callback) => {
    let nextLastOrder = order

    // Set this value if need to "add header"
    let headerSetNumber = null
    if (!lastOrder) {
        // First item
        headerSetNumber = currentSetNumber
    }
    else if (lastOrder.set_number && order.set_number) {
        if (lastOrder.set_number == order.set_number) {
            // Still in same set, no need header
        }
        else if (lastOrder.set_number != order.set_number) {
            // Change set, move to next set number
            currentSetNumber++
            headerSetNumber = currentSetNumber
        }
    }
    callback && callback(currentSetNumber, nextLastOrder)

    if (headerSetNumber) {
        return headerSetNumber
    }
}


class Order {
    constructor(){
        if(!Order.instance){
            this.app = null
            Order.instance = this
        }
        return Order.instance;
    }

    getDraftAndConfirmOrderTotal(){
        let total = 0
        this.getOrders(["draft", "confirmed"]).forEach(order => {
            total += parseFloat(order.order_total)
        });
        return total
    }
    getConfirmedOrderTotal(){
        let total = 0
        this.getConfirmedOrders().forEach(order => {
            total += parseFloat(order.order_total)
        });
        return total
    }
    payBill(options) {
        if (options) {
            this.payBillNoPrompt(options)
        }
        else {
            let message = lang.ask_pay_bill.replace("<br>", "\n");
            if(confirm(message)){
                this.payBillNoPrompt(options)
            }
        }
    }
    payBillNoPrompt(options) {
        $.ajax({
            url: `/bills`,
            type: 'post',
            data: {
                table_session_id: this.app.state.current_session.id,
            },
            success: (response) => {
                if (options && options.callback) {
                    options.callback(response)
                }
            }
        })
    }
    getConfirmedOrders(){
        return this.app && (this.app.state.orders || []).filter((order) => order.order_status == "accepted") || []
    }
    getDraftOrders(){
        return this.app && (this.app.state.orders || []).filter((order) => order.order_status == "draft") || []
    }
    getOrders(orderStatuses){
        return this.app && (this.app.state.orders || []).filter((order) => orderStatuses.indexOf(order.order_status) !== -1) || []
    }
    init(app) {
        this.app = app
        Object.freeze(Order.instance);
    }
}

const instance = new Order();
export default instance;